"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashFunction = void 0;
class HashFunction {
    constructor(typeHex) {
        this.typeHex = typeHex;
        this.checkSum = `fe4e5459${this.typeHex}`;
    }
    signedHashing(data, account) {
        const hashedData = this.hashing(data);
        return account.signData(hashedData);
    }
    signedHashingFromHashedData(hashedData, account) {
        return account.signData(hashedData);
    }
    createApostilleTransactionMessage(data, account) {
        const signedHash = this.signedHashing(data, account);
        return `${this.checkSum}${signedHash}`;
    }
    createApostilleTransactionMessageFromHashedData(hashedData, account) {
        const signedHash = this.signedHashingFromHashedData(hashedData, account);
        return `${this.checkSum}${signedHash}`;
    }
}
exports.HashFunction = HashFunction;
//# sourceMappingURL=HashFunction.js.map